<template lang="pug">
  .push-list(ref="push-list" :style="{ bottom: `${margin}px` }")
    TransitionGroup.items(name="slide" tag="div")
      PushItem(v-for="item in $store.state.push.items" :key="item.id" :item="item")
</template>

<script>
import PushItem from '@/components/app/push/PushItem.vue';

export default {
  name: 'PushList',
  components: { PushItem },
  data() {
    return {
      margin: 0,
    };
  },
  resizeObserver: null,
  mounted() {
    setTimeout(this.onScroll, 2000);
    document.addEventListener('scroll', this.onScroll);
    this.$options.resizeObserver = new ResizeObserver(this.onScroll);
    this.$options.resizeObserver.observe(document.body);
  },
  beforeDestroy() {
    document.removeEventListener('scroll', this.onScroll);
    this.$options.resizeObserver.disconnect();
  },
  methods: {
    onScroll() {
      const footerBar = document.querySelector('.js-footer-edge');
      if (!footerBar) return;

      this.margin = window.innerHeight - footerBar.getBoundingClientRect().top;
    },
  },
};
</script>

<style scoped lang="scss">
  .push-list {
    position: fixed;
    bottom: 0;
    right: 0;
    width: 320px;

    padding: 7px;
    z-index: 999999999999999;
  }

  .items {
    display: flex;
    gap: 7px;
    flex-direction: column;
  }

  @media (max-width: 576px) {
    .push-list {
      width: 100%;
      box-sizing: border-box;
    }
  }

  .slide {
    &-move {
      transition: all 0.5s;
    }

    &-enter-active {
      animation: slide-in 0.5s ease-out forwards;
    }

    &-leave-active {
      animation: slide-out 0.5s ease-out forwards;
      opacity: 0;
      position: fixed;
    }
  }

  @keyframes slide-in {
    from {
      transform: translateY(100px);
      opacity: 0;
    }
    to {
      transform: translateY(0px);
      opacity: 1;
    }
  }

  @keyframes slide-out {
    from {
      transform: translateX(0px);
      opacity: 1;
    }
    to {
      transform: translateX(400px);
      opacity: 0;
    }
  }
</style>
